import tripledes from 'crypto-js/tripledes'
import CryptoJS from 'crypto-js'
import { encryptByMd5 } from '@aomi/utils'

import { useAppStore, useWebviewStore } from '@/store'

const KEY = '1xS#j12@qw%kaq*(1xS#j12@qw%kaq*(1xS#j12@qw%kaq*('
const keyHex = CryptoJS.enc.Utf8.parse(KEY)

export function encrypt(text: string) {
  const plainText = text
  const cipherText = tripledes.encrypt(plainText, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return cipherText.toString()
}

export function hashAndEncrypt(text: string, timestamp: number) {
  const plainText = encryptByMd5(text) + timestamp
  const cipherText = tripledes.encrypt(plainText, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return cipherText.toString()
}

export function hashWithSalt(pwd: string, timestamp: number) {
  const { tempKey } = useAppStore()
  const { isNeedValidateDevice } = useWebviewStore()

  if (isNeedValidateDevice) {
    return encryptByMd5(encryptByMd5(encryptByMd5(pwd) + timestamp + tempKey))
  }
  return encryptByMd5(encryptByMd5(encryptByMd5(pwd)) + timestamp)
}

/**
 * 加密参数 对需要加密的参数进行统一加密处理
 * @param params
 * @returns
 */
export function encryptParam(params: any) {
  console.log('[加密前的参数] ', JSON.parse(JSON.stringify(params)))

  if (!params) {
    return params
  }

  const needEncryptParams = [
    // 需要加密的属性
    'cardNo',
    'name',
    'idNo',
    'phone',
    'cvn2',
    'expiryDate',
  ]

  needEncryptParams.forEach((key) => {
    if (params[key]) {
      if (key === 'name') {
        params[key] = encrypt(params[key].toUpperCase())
      } else {
        params[key] = encrypt(params[key])
      }
    }
  })

  console.log('[加密后的参数] ', JSON.parse(JSON.stringify(params)))
  return params
}

/**
 * 加密密码
 * - 密码和旧密码使用hashWithSalt加密
 * - 新密码则用hashAndEncrypt加密
 * @param params
 * @returns
 */
export function encryptPwdAndSetTimestamp(params: any) {
  const paramsCopy = JSON.parse(JSON.stringify(params))
  const timestamp = new Date().getTime()
  const needEncryptParams = ['password', 'oldPassword', 'newPassword']

  needEncryptParams.forEach((key) => {
    if (paramsCopy[key]) {
      if (key === 'newPassword') {
        paramsCopy[key] = hashAndEncrypt(paramsCopy[key], timestamp)
      } else {
        paramsCopy[key] = hashWithSalt(paramsCopy[key], timestamp)
      }
    }
  })
  paramsCopy.timestamp = timestamp
  console.log('[加密密码后的参数] ', JSON.parse(JSON.stringify(paramsCopy)))
  return paramsCopy
}
